import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import { Button, Card, Colors, CardContainer, ExpandableCard, getSpacing, Text, useAlert, getShadow } from '@rahtab/ui';
import { Screen } from '@rahtab/stack-navigator';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import PendingIcon from '@rahtab/ui/dist/icons/PendingIcon';
import { RootStackType } from '../Router';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { RouteProp } from '@react-navigation/native';
import { getUsername } from '@rahtab/auth/lib/token-based-auth/helpers';

const TermsOfService: React.FC<TermsOfServiceProps> = ({ route }) => {
  const alert = useAlert();
  const { reset } = useNavigation<NavigationProp<RootStackType>>();

  const WithIndex = ({
    index,
    title,
    value,
    marginVertical,
    marginTop,
  }: {
    index: number;
    title: string;
    value: string;
    marginVertical?: boolean;
    marginTop?: boolean;
  }) => (
    <Text
      style={StyleSheet.flatten([
        { textAlign: 'justify' },
        marginVertical && { marginVertical: getSpacing() },
        marginTop && { marginTop: getSpacing() },
      ])}>
      {index}.<Text color="primary"> {title}:</Text>
      <Text
        style={{
          flex: 1,
        }}>
        {' '}
        {value}
      </Text>
    </Text>
  );

  const WithBullet = ({
    value,
    marginTop,
    marginVertical,
  }: {
    value: string;
    marginTop?: boolean;
    marginVertical?: boolean;
  }) => (
    <View
      style={StyleSheet.flatten([
        styles.rowView,
        { textAlign: 'justify' },
        marginVertical && { marginVertical: getSpacing() },
        marginTop && { marginTop: getSpacing() },
      ])}>
      <PendingIcon style={{ marginRight: getSpacing(0.5), marginTop: getSpacing(0.7) }} />
      <Text
        style={{
          flex: 1,
          textAlign: 'justify',
        }}>
        {' '}
        {value}
      </Text>
    </View>
  );

  const handleButton = async () => {
    try {
      const username = await getUsername();
      if (username !== null) {
        await AsyncStorage.setItem(`${username}-Agreement`, 'agreed', () =>
          reset({
            index: 0,
            routes: [{ name: 'Home' }],
          }),
        );
      }
    } catch (e) {
      alert({ title: 'خطا', message: 'مشکلی در ذخیره اطلاعات پیش آمده است.' });
    }
  };
  return (
    <Screen
      title="قوانین و مقررات همکاری با شبکه رهتاب"
      renderMain={() => {
        return (
          <ScrollView>
            <Card style={styles.card}>
              <CardContainer>
                <Text
                  style={{
                    textAlign: 'justify',
                  }}>
                  <Text color="primary">شفافیت عملکرد</Text>
                  <Text> و </Text>
                  <Text color="secondary">مشتری مداری </Text>
                  از بالاترین ارزش‌های سازمانی شبکه رهتاب است. حصول اطمینان از توزیع و فروش هوشمندانه کالا هدف اصلی این
                  شبکه بوده و از این رو شفافیت عملکرد و ثبت اطلاعات صحیح و تعهد به قوانین شبکه رهتاب توسط پذیرندگان
                  ضروری است. همچنین از آنجا که شهروندان مشتری تمام پذیرندگان شبکه رهتاب هستند، جلب رضایت آن‌ها باید
                  اولین و بالاترین اولویت همه‌ی ما باشد.
                </Text>
                <Text
                  style={{
                    textAlign: 'justify',
                  }}>
                  عملکرد فروشندگان بر اساس چندین معیار شامل میزان رضایت‌مندی شهروندان، نتایج بازرسی سازمان‌های نظارتی و
                  همچنین ارزیابی عملکرد توسط شبکه رهتاب سنجیده خواهد شد و امتیاز هر فروشنده محاسبه می‌شود و فروشندگانی
                  که از عملکرد و استاندارد باکیفیت مورد نظر برخوردار نباشند با آن‌ها قطع همکاری خواهد شد.
                </Text>
                <Text
                  style={{
                    textAlign: 'justify',
                  }}>
                  در ادامه به اختصار قوانین و مقررات همکاری پذیرندگان با شبکه رهتاب ارائه شده است. توجه کنید که موافقت
                  با این قوانین و مقررات به منزله قبول شرایط همکاری با شبکه رهتاب تلقی شده و رعایت تمامی این قوانین از
                  سوی پذیرنده مورد انتظار بوده و در صورت تخلف از آن‌ها شبکه رهتاب حق قطع همکاری با پذیرنده را دارا خواهد
                  بود.
                </Text>
                <ExpandableCard
                  title="قوانین مربوط به فروش در شبکه رهتاب"
                  titleColor="primary"
                  style={styles.expandable}>
                  <Text
                    style={{
                      textAlign: 'justify',
                    }}>
                    کالاهای تامین شده و عرضه شده در شبکه رهتاب را می‌توان به دو دسته اصلی زیر تقسیم کرد.
                  </Text>
                  <WithIndex
                    index={1}
                    title="کالاهای تنظیم بازاری"
                    value="این کالاها که غالبا شامل کالاهای ضروری و اساسی می‌باشند عموما توسط سازمان‌های تامین کننده و مجوز دهنده دولتی تامین و عرضه می‌شوند. همچنین از آنجا که شبکه رهتاب تنها بستر فروش قانونی این کالاها در سراسر استان اصفهان می‌باشد، فروش این کالاها خارج از سامانه رهتاب تخلف محسوب شده و مورد پیگرد سازمان‌های نظارت و بازرسی قرار خواهد گرفت."
                  />
                  <WithIndex
                    index={2}
                    marginVertical
                    title="کالاهای غیر تنظیم بازاری"
                    value="این کالاها توسط تامین کنندگان شبکه رهتاب در این سامانه عرضه می‌شوند و با قیمت یکسان در تمامی پذیرندگان شبکه رهتاب به فروش خواهند رسید. پذیرندگان در صورت تمایل به دریافت این گونه کالاها می‌بایست با قیمت مصرف کننده مورد توافق به فروش بپردازند."
                  />
                  <Text
                    style={{
                      textAlign: 'justify',
                    }}>
                    هر زمانی که کالا و یا بار جدیدی در سامانه رهتاب عرضه شود از همه پذیرندگان و توزیع‌کنندگان مربوطه
                    نیازسنجی خواهد شد و در صورت تمایل ایشان و پس از ثبت سفارش در سامانه رهتاب، موجودی مورد نیاز آنها
                    توسط توزیع‌کنندگان شبکه تامین خواهد شد.
                  </Text>
                  <WithBullet
                    marginVertical
                    value="لازم به ذکر است که به صورت کلی فروش کالاهای توزیع شده در شبکه رهتاب، خارج از این شبکه تخلف بوده و در صورت مشاهده مورد پیگیری قرار خواهد گرفت."
                  />
                  <WithBullet value="دقت نمایید که ثبت فروش کالا در سامانه باید قبل از تحویل کالا به شهروند انجام شود چرا که در غیر این صورت ممکن است ثبت فروش کالا برای آن شهروند مجاز نبوده و یا موفقیت‌آمیز نباشد که در این صورت موجودی فروشگاه در سامانه با موجودی واقعی فروشگاه مطابق نبوده و مسئولیت این مغایرت به عهده پذیرنده است." />
                  <WithBullet
                    marginTop
                    value="همچنین در صورت ثبت فروش موفقیت آمیز کالاهای تنظیم‌بازاری و عدم تحویل کالا به هر علت که منجر به مصرف شدن سهمیه شهروند خواهد شد، کلیه مسئولیت تامین کالای مربوطه و عرضه به شهروند بر عهده پذیرنده خواهد بود."
                  />
                </ExpandableCard>
                <ExpandableCard
                  title="تطابق اطلاعات موجودی سامانه با موجودی واقعی"
                  titleColor="primary"
                  style={styles.expandable}>
                  <Text
                    style={{
                      textAlign: 'justify',
                    }}>
                    همانطور که پیشتر عنوان شد، شفافیت عملکرد به منظور حصول اعتماد عمومی شهروندان و سازمان‌های ذیربط هدف
                    اصلی شبکه رهتاب بوده و از این رو شفافیت فرآیند توزیع و فروش کالا و متعاقبا تطابق موجودی فروشگاه در
                    سامانه با موجودی واقعی فروشگاه ضروری است. از آنجا که گاها امکان دارد که مغایرت موجودی سامانه با
                    موجودی واقعی فروشگاه اتفاق بیافتد، پذیرنده موظف است که به صورت مداوم تطابق سنجی نماید و در صورت
                    مغایرت موجودی به اصلاح موجودی خویش بپردازد. اصلاح موجودی در سامانه رهتاب در دو مرحله امکان‌پذیر است.
                  </Text>
                  <WithIndex
                    index={1}
                    marginTop
                    title="اعلام وصول بار دریافتی"
                    value="پذیرنده می‌بایست در هنگام اعلام وصول بار دریافتی در سامانه مقدار بار دریافتی واقعی را با مقدار ثبت شده در سامانه تطابق داده و در صورت مغایرت مقدار اختلاف را وارد کند تا موجودی دریافتی فروشگاه اصلاح شود."
                  />
                  <WithIndex
                    index={2}
                    title="پس از عرضه بار دریافتی"
                    value="ممکن است پس از گذشت مدتی از عرضه کالا در فروشگاه، موجودی سامانه با موجودی واقعی فروشگاه مغایرت حاصل کند که در این صورت پذیرنده می‌بایست علت مغایرت را جست و جو کرده و سریعا به میزکار خود در سامانه رهتاب مراجعه کند و با ذکر دلیل مغایرت موجودی و توضیحات مرتبط با آن، موجودی خود را اصلاح نماید."
                  />
                </ExpandableCard>
                <ExpandableCard
                  title="قیمت‌گذاری کالا برای فروش به مصرف کننده"
                  titleColor="primary"
                  style={styles.expandable}>
                  <Text
                    style={{
                      textAlign: 'justify',
                    }}>
                    قیمت فروش کالا در شبکه رهتاب به دو صورت تعیین می‌شود.
                  </Text>
                  <WithIndex
                    index={1}
                    marginVertical
                    title="قیمت‌گذاری توسط سازمان مجوز دهنده"
                    value="در حالت قیمت فروش مصرف‌کننده توسط سازمان‌ مجوز دهنده مرتبط تحت عنوان قیمت مصوب مصرف کننده تعیین شده و امکان تغییر قیمت مصرف کننده توسط پذیرنده وجود ندارد. اکثر کالاهای تنظیم بازاری به این صورت قیمت گذاری می‌شوند. بدیهی است که فروش کالا با قیمت بالاتر از قیمت مصوب غیر قانونی بوده و در صورت تخلف، سازمان‌های نظارت و بازرسی با پذیرنده متخلف برخورد خواهند کرد."
                  />
                  <WithIndex
                    index={2}
                    title="قیمت گذاری توسط فروشگاه"
                    value="در این حالت قیمت‌گذاری توسط فروشگاه انجام می‌شود. در این نوع از قیمت‌گذاری ضروری است که توجه شود که قیمت ثبت شده بیشتر از قیمت مصرف کننده مندرج بر روی بسته‌بندی کالا (در صورت وجود) و یا بیشتر از قیمت توافق شده با شبکه رهتاب (در صورت توافق) نباشد."
                  />
                </ExpandableCard>
                <ExpandableCard title="ثبت‌نام شهروندان توسط پذیرندگان" titleColor="primary" style={styles.expandable}>
                  <Text
                    style={{
                      textAlign: 'justify',
                    }}>
                    علاوه بر بسترهای متنوع ثبت‌نام که در اختیار شهروندان قرار داده شده است، پذیرندگان شبکه رهتاب نیز
                    می‌توانند مراجعینی که عضو شبکه رهتاب نیستند را ثبت‌نام کنند. باید به این نکته توجه کرد که اطلاعات
                    اعلام شده توسط شهروندان در هنگام ثبت‌نام به وسیله تطابق سنجی با بانک اطلاعاتی سازمان ثبت احوال و
                    سایر بانک‌های اطلاعاتی مورد صحت‌سنجی قرار می‌گیرد، از این رو نباید قبل از حصول اطمینان از ثبت‌نام
                    موفق شهروندان، به فروش و تحویل کالا به ایشان اقدام نمود.
                  </Text>
                  <WithBullet
                    marginVertical
                    value="در صورت اقدام تحویل کالا پیش از ثبت‌نام کامل شهروند و موفقیت‌آمیز نبودن ثبت‌نام وی، مقدار فروخته شده به شهروند در سامانه محاسبه نخواهد شد و مسئولیت عدم تطابق اطلاعات موجودی سامانه با موجودی واقعی فروشگاه به عهده پذیرنده می‌باشد."
                  />
                  <WithBullet value="همچنین در صورت ذخیره کردن اطلاعات شخصی شهروندان و سو استفاده از این اطلاعات در صورت وجود شکایت، مراتب مربوطه به سازمان‌های نظارت و بازرسی مربوطه گزارش داده خواهد شد و شبکه رهتاب هیچ مسئولیتی در این رابطه نخواهد داشت." />
                </ExpandableCard>
                <Button
                  color="primary"
                  text="پذیرش قوانین و مقررات سامانه رهتاب"
                  onPress={() => {
                    alert({
                      title: 'هشدار',
                      message: `آیا قوانین و مقررات همکاری پذیرندگان با شبکه رهتاب را به صورت کامل مطالعه کرده‌اید؟ \n توجه نمایید که موافقت با این قوانین و مقررات به منزله قبول شرایط همکاری با شبکه رهتاب تلقی شده و رعایت تمامی این قوانین از سوی پذیرنده مورد انتظار خواهد بود.`,
                      buttons: [
                        {
                          color: 'secondary',
                          text: 'ادامه',
                          onPress: () => handleButton(),
                        },
                      ],
                    });
                  }}
                />
              </CardContainer>
            </Card>
          </ScrollView>
        );
      }}
    />
  );
};
export default TermsOfService;

const styles = StyleSheet.create({
  card: {
    margin: getSpacing(),
    backgroundColor: Colors.white,
  },
  expandable: {
    backgroundColor: Colors.background,
    marginBottom: getSpacing(),
    ...getShadow({ elevation: 0 }),
  },
  rowView: {
    flexDirection: 'row',
  },
});

interface TermsOfServiceProps {
  route: RouteProp<RootStackType, 'TermsOfService'>;
}
